import React, { useState } from "react";
import { ReactComponent as SearchIcon } from "../../../assets/images/Searchicon.svg";
import { ReactComponent as ImportIcon } from "../../../assets/images/Import.svg";

import { AppMaterialIcons } from "../../../AppComponents/AppMaterialIcons";
import { StyledAppInput } from "../../BotBuilder/BotKnowledge/BotKnowledgeStyles";
import AppButton from "../../../AppComponents/AppButton";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Divider,
  MenuItem,
} from "@mui/material";
import { StyledInput, StyledLabel, StyledSelect } from "../style";
import AppModel from "../../../Hooks/useModel/AppModel";
import { convertCurlToJson } from "./utils";

const TopMenuComponent = (props: any) => {
  const navigate = useNavigate();

  // Handler function to handle selection

  const handleNavigations = () => {
    navigate("/webhook/library/create");
  };

  return (
    <div className="topmenu">
      <div
        className="menu-left"
        onClick={() => (props?.hideFilters ? navigate("/webhook/library") : null)}
      >
        {props?.hideFilters ? (
          <AppMaterialIcons
            iconName={"ArrowBackIosOutlined"}
            style={{ fontSize: "18px", marginRight: "-25px" }}
          />
        ) : null}
        Webhook Library
      </div>
      {!props?.hideFilters ? (
        <div className="menu-right">
          <div className="faq-search" style={{ marginRight: "1rem" }}>
            <div className="faq-search" style={{ marginRight: "1rem" }}>
              <StyledAppInput>
                <input
                  type="text"
                  onChange={(e: any) =>
                    props?.handleSelectSearch(e.target.value)
                  }
                  name="query"
                  id="query"
                  placeholder="Search"
                />
                <SearchIcon />
              </StyledAppInput>
            </div>
          </div>
          {/* <StyledSelect
            value={props?.method}
            onChange={props?.handleChangeMethod}
            displayEmpty
            sx={{
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#FF5722", // Custom color for the border
              },
              ".Mui-selected": {
                color: "#FF5722", // Custom color for the selected text
              },
            }}
          >
            <MenuItem value="" disabled>
              Filter by method
            </MenuItem>

            <MenuItem value="">ALL</MenuItem>
            <MenuItem value="GET">GET</MenuItem>
            <MenuItem value="POST">POST</MenuItem>
            <MenuItem value="put">PUT</MenuItem>
            <MenuItem value="delete">DELETE</MenuItem>
            <MenuItem value="patch">PATCH</MenuItem>
          </StyledSelect> */}
          <AppButton
            buttonStyle={{
              marginRight: "5px",
              padding: "14px 10px 14px 3px",
            }}
            onClick={handleNavigations}
          >
            <AppMaterialIcons iconName="add" />
            Create
          </AppButton>
        </div>
      ) : null}
    </div>
  );
};

export default TopMenuComponent;
